// import React from "react";
// import { IoMdClose } from "react-icons/io";
// import Helper from "../../helper";
// import "./PlaceBet.css"; // your existing CSS
// import "react-toastify/dist/ReactToastify.css";

// const PlaceBet = (props) => {
//   const userInfo = Helper();
//   const isBack = props?.type === "back";
//   const backgroundColor = isBack ? "back-bg" : "lay-bg";

//   const handleCalcyClick = (value) => {
//     const current = props?.StakeValue?.toString() || "";
//     if (value === "⌫") {
//       const updated = current.slice(0, -1);
//       props?.placeStakeValue(updated ? Number(updated) : 0);
//     } else {
//       const updated = current + value;
//       props?.placeStakeValue(Number(updated));
//     }
//   };

//   const calcyKeys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "00", ".", "⌫"];

//   return (
//     <div
//       className={`placebet-container ${backgroundColor}`}
//     // style={{ width: "90vw" }}
//     >
//       <div className="placebet-header text-[#000]">
//         <p className="placebet-title">
//           {isBack ? "Back" : "Lay"}: {props?.BetPlaceData?.runner_name}
//         </p>
//         <IoMdClose
//           className="placebet-close"
//           onClick={() => props?.handleClosePlaceBet()}
//         />
//       </div>

//       <div className="flex justify-between items-center text-center">
//         {/* Odds Input */}
//         <div className="flex justify-center items-center h-8 text-[#000]">
//           <button className="flex justify-center items-center w-9 h-full bg-[#A4A4A4] border border-gray-500">
//             -
//           </button>
//           <input
//             type="number"
//             className="flex justify-center items-center text-center text-sm w-full h-full border border-gray-500"
//             value={props?.BetPlaceData.price}
//             readOnly
//           />
//           <button className="flex justify-center items-center w-9 h-full bg-[#A4A4A4] border border-gray-500">
//             +
//           </button>
//         </div>

//         {/* Stake Input */}
//         <div className="flex justify-center items-center h-8 ml-1 text-[#000]">
//           <button
//             className="flex justify-center items-center w-9 h-full bg-[#A4A4A4] border border-gray-500"
//             onClick={() =>
//               props?.placeStakeValue(
//                 props?.StakeValue > 0 ? props?.StakeValue - 100 : 0
//               )
//             }
//           >
//             -
//           </button>
//           <input
//             type="number"
//             className="flex justify-center items-center text-center text-sm w-full h-full border border-gray-500"
//             value={props?.StakeValue || ""}
//             onChange={(e) => props?.placeStakeValue(Number(e.target.value))}
//           />
//           <button
//             className="flex justify-center items-center w-9 h-full bg-[#A4A4A4] border border-gray-500"
//             onClick={() => props?.placeStakeValue(props?.StakeValue + 100)}
//           >
//             +
//           </button>
//         </div>
//       </div>

//       {/* Chips */}
//       <div className="chip-actions flex flex-wrap ">
//         {[
//           100, 500, 1000, 50000, 100000, 200000,

//         ].map((chip, index) => {
//           const value = typeof chip === "object" ? chip.value : chip;
//           const label = typeof chip === "object" ? chip.label : chip;
//           const className = typeof chip === "object" ? chip.className : "";
//           return (
//             <button
//               key={index}
//               className={`chip-action ${className}  text-[#000] border-r-[1px] border-[#dee2e6] `}
//               onClick={() =>
//                 chip.label === "All In"
//                   ? null
//                   : props?.placeStakeValue(value)
//               }
//             >
//               {label}
//             </button>
//           );
//         })}
//       </div>

//       <div className="grid grid-cols-7  ">
//         {/* Row 1: 1–6 */}
//         {["1", "2", "3", "4", "5", "6"].map((key, index) => (
//           <button
//             key={`row1-${index}`}
//             className="bg-white text-[#000] text-center py-2 h-10 border border-gray-400 text-sm font-medium hover:bg-gray-300 transition-all"
//             onClick={() => handleCalcyClick(key)}
//           >
//             {key}
//           </button>
//         ))}

//         {/* ⌫ Button - spans 2 rows */}
//         <button
//           className="row-span-2 bg-white  text-black text-center py-2 h-full  border border-gray-400 text-sm font-medium hover:bg-red-600 transition-all"
//           onClick={() => handleCalcyClick("⌫")}
//         >
//           ⌫
//         </button>

//         {/* Row 2: 7–. */}
//         {["7", "8", "9", "0", "00", "."].map((key, index) => (
//           <button
//             key={`row2-${index}`}
//             className=" bg-white text-[#000] text-center py-2 h-10 border border-gray-400 text-sm font-medium hover:bg-gray-300 transition-all"
//             onClick={() => handleCalcyClick(key)}
//           >
//             {key}
//           </button>
//         ))}
//       </div>


//       {/* <p className="bet-limit">Min Bet: 10 Max Bet: 100000</p> */}

//       {userInfo && (
//         <div className="action-buttons">
//           <button
//             className="cancel-btn"
//             onClick={() => {
//               props?.setShowBetsSlip(false);
//               props?.setSelection_id("");
//               props?.setHtmlId("");
//               props?.handleClosePlaceBet();
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             className="place-btn"
//             onClick={() =>
//               props?.placing ? console.log("Placing....") : props?.betPlace()
//             }

//             disabled={!props?.StakeValue}
//           >
//             {props?.placing ? "Placing..." : "Placebet"}
//           </button>
//         </div>
//       )}
//       <div className="flex flex-col gap-1 mt-2">
//         {/* {(() => {
//           let runners = Array.isArray(props?.BetPlaceData?.runners) && props.BetPlaceData.runners.length > 0
//             ? props.BetPlaceData.runners
//             : [
//               ...(props?.BetPlaceData?.team1 ? [{ runner_name: props.BetPlaceData.team1, exposure: 0 }] : []),
//               ...(props?.BetPlaceData?.team2 ? [{ runner_name: props.BetPlaceData.team2, exposure: 0 }] : []),
//               ...(props?.BetPlaceData?.runner_name && !props?.BetPlaceData?.team1 && !props?.BetPlaceData?.team2
//                 ? [{ runner_name: props.BetPlaceData.runner_name, exposure: 0 }]
//                 : []),
//             ];
//           return runners.map((runner) => (
//             <div key={runner.runner_name} className="flex items-center justify-between gap-2">
//               <span className="text-[#000] text-sm font-bold">{runner.runner_name}</span>
//               <span
//                 className={
//                   runner.exposure > 0
//                     ? 'text-green-700 text-sm font-bold'
//                     : runner.exposure < 0
//                       ? 'text-red-600 text-sm font-bold'
//                       : 'text-gray-700 text-sm font-bold'
//                 }
//               >
//                 {typeof runner.exposure === 'number' ? runner.exposure.toFixed(2) : '0.00'}
//               </span>
//             </div>
//           ));
//         })()} */}

//         {(() => {
//           const runners = Array.isArray(props?.BetPlaceData?.runners) && props.BetPlaceData.runners.length > 0
//             ? props.BetPlaceData.runners
//             : [
//               ...(props?.BetPlaceData?.team1 ? [{ runner_name: props.BetPlaceData.team1, selection_id: "team1", exposure: 0 }] : []),
//               ...(props?.BetPlaceData?.team2 ? [{ runner_name: props.BetPlaceData.team2, selection_id: "team2", exposure: 0 }] : []),
//               ...(props?.BetPlaceData?.runner_name && !props?.BetPlaceData?.team1 && !props?.BetPlaceData?.team2
//                 ? [{ runner_name: props.BetPlaceData.runner_name, selection_id: props?.BetPlaceData?.selection_id, exposure: 0 }]
//                 : []),
//             ];

//           return runners.map((runner) => {
//             let exposure = runner.exposure;
//             const odds = parseFloat(props?.BetPlaceData?.price);
//             const stake = parseFloat(props?.StakeValue) || 0;
//             if (props?.StakeValue && props?.BetPlaceData?.price) {
//               if (runner.selection_id === props?.BetPlaceData?.selection_id) {
//                 if (props?.type === "back") {
//                   exposure = ((odds - 1) * stake);
//                 } else {
//                   exposure = ((odds - 1) * stake * -1);
//                 }
//               } else {
//                 if (props?.type === "back") {
//                   exposure = -stake;
//                 } else {
//                   exposure = stake;
//                 }
//               }
//             }
//             return (
//               <div key={runner.runner_name} className="flex items-center justify-between gap-2">
//                 <span className="text-[#000] text-sm font-bold">
//                   {runner.runner_name}
//                 </span>
//                 <span
//                   className={
//                     exposure > 0
//                       ? 'text-green-700 text-sm font-bold'
//                       : exposure < 0
//                         ? 'text-red-600 text-sm font-bold'
//                         : 'text-gray-700 text-sm font-bold'
//                   }
//                 >
//                   <span
//                     style={{
//                       marginLeft: 8,
//                       color: exposure < 0
//                         ? "#ff0000"
//                         : exposure > 0
//                           ? "#228b22"
//                           : "#000000", // black for zero
//                       fontWeight: "bold",
//                       fontSize: "0.9em"
//                     }}
//                   >
//                     {typeof exposure === 'number' ? exposure.toFixed(2) : '0.00'}
//                   </span>
//                 </span>
//               </div>
//             );
//           });
//         })()}
//       </div>
//     </div>
//   );
// };

// export default PlaceBet;


import React, { useEffect, useRef } from "react";
import { IoMdClose } from "react-icons/io";
import Helper from "../../helper";
import "./PlaceBet.css"; // your existing CSS
import "react-toastify/dist/ReactToastify.css";

const PlaceBet = (props) => {
  const userInfo = Helper();
  const isBack = props?.type === "back";
  const backgroundColor = isBack ? "back-bg" : "lay-bg";

  const timeoutRef = useRef(null);

  useEffect(() => {
    // Start 7 second countdown
    timeoutRef.current = setTimeout(() => {
      if (!props?.placing) {
        props?.handleClosePlaceBet?.();
        props?.setShowBetsSlip?.(false);
        props?.setSelection_id?.("");
        props?.setHtmlId?.("");
      }
    }, 7000);

    // Clear timeout if placing starts or on unmount
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  const handleCalcyClick = (value) => {
    const current = props?.StakeValue?.toString() || "";
    if (value === "⌫") {
      const updated = current.slice(0, -1);
      props?.placeStakeValue(updated ? Number(updated) : 0);
    } else {
      const updated = current + value;
      props?.placeStakeValue(Number(updated));
    }
  };

  const calcyKeys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "00", ".", "⌫"];

  return (
    <div
      className={`placebet-container ${backgroundColor}`}
    // style={{ width: "90vw" }}
    >
      {/* ===== EXISTING CONTENT STARTS HERE (No changes) ===== */}
      <div className="placebet-header text-[#000]">
        <p className="placebet-title">
          {isBack ? "Back" : "Lay"}: {props?.BetPlaceData?.runner_name}
        </p>
        <IoMdClose
          className="placebet-close"
          onClick={() => props?.handleClosePlaceBet()}
        />
      </div>

      <div className="flex justify-between items-center text-center">
        {/* Odds Input */}
        <div className="flex justify-center items-center h-8 text-[#000]">
          <button className="flex justify-center items-center w-9 h-full bg-[#A4A4A4] border border-gray-500">
            -
          </button>
          <input
            type="number"
            className="flex justify-center items-center text-center text-sm w-full h-full border border-gray-500"
            value={props?.BetPlaceData.price}
            readOnly
          />
          <button className="flex justify-center items-center w-9 h-full bg-[#A4A4A4] border border-gray-500">
            +
          </button>
        </div>

        {/* Stake Input */}
        <div className="flex justify-center items-center h-8 ml-1 text-[#000]">
          <button
            className="flex justify-center items-center w-9 h-full bg-[#A4A4A4] border border-gray-500"
            onClick={() =>
              props?.placeStakeValue(
                props?.StakeValue > 0 ? props?.StakeValue - 100 : 0
              )
            }
          >
            -
          </button>
          <input
            type="number"
            className="flex justify-center items-center text-center text-sm w-full h-full border border-gray-500"
            value={props?.StakeValue || ""}
            onChange={(e) => props?.placeStakeValue(Number(e.target.value))}
          />
          <button
            className="flex justify-center items-center w-9 h-full bg-[#A4A4A4] border border-gray-500"
            onClick={() => props?.placeStakeValue(props?.StakeValue + 100)}
          >
            +
          </button>
        </div>
      </div>

      {/* Chips */}
      <div className="chip-actions flex flex-wrap ">
        {[
          100, 500, 1000, 50000, 100000, 200000,

        ].map((chip, index) => {
          const value = typeof chip === "object" ? chip.value : chip;
          const label = typeof chip === "object" ? chip.label : chip;
          const className = typeof chip === "object" ? chip.className : "";
          return (
            <button
              key={index}
              className={`chip-action ${className}  text-[#000] border-r-[1px] border-[#dee2e6] `}
              onClick={() =>
                chip.label === "All In"
                  ? null
                  : props?.placeStakeValue(value)
              }
            >
              {label}
            </button>
          );
        })}
      </div>

      <div className="grid grid-cols-7  ">
        {/* Row 1: 1–6 */}
        {["1", "2", "3", "4", "5", "6"].map((key, index) => (
          <button
            key={`row1-${index}`}
            className="bg-white text-[#000] text-center py-2 h-10 border border-gray-400 text-sm font-medium hover:bg-gray-300 transition-all"
            onClick={() => handleCalcyClick(key)}
          >
            {key}
          </button>
        ))}

        {/* ⌫ Button - spans 2 rows */}
        <button
          className="row-span-2 bg-white  text-black text-center py-2 h-full  border border-gray-400 text-sm font-medium hover:bg-red-600 transition-all"
          onClick={() => handleCalcyClick("⌫")}
        >
          ⌫
        </button>

        {/* Row 2: 7–. */}
        {["7", "8", "9", "0", "00", "."].map((key, index) => (
          <button
            key={`row2-${index}`}
            className=" bg-white text-[#000] text-center py-2 h-10 border border-gray-400 text-sm font-medium hover:bg-gray-300 transition-all"
            onClick={() => handleCalcyClick(key)}
          >
            {key}
          </button>
        ))}
      </div>


      {/* {!userInfo && ( */}
      <div className="action-buttons">
        <button
          className="cancel-btn"
          onClick={() => {
            props?.setShowBetsSlip(false);
            props?.setSelection_id("");
            props?.setHtmlId("");
            props?.handleClosePlaceBet();
          }}
        >
          Cancel
        </button>
        <button
          className="place-btn"
          onClick={() =>
            props?.placing ? console.log("Placing....") : props?.betPlace()
          }

          disabled={!props?.StakeValue}
        >
          {/* The text for this button is already handled by props.placing */}
          {props?.placing ? "Placing..." : "Placebet"}
        </button>
      </div>
      {/* // )} */}
      <div className="flex flex-col gap-1 mt-2">
        {(() => {
          const runners = Array.isArray(props?.BetPlaceData?.runners) && props.BetPlaceData.runners.length > 0
            ? props.BetPlaceData.runners
            : [
              ...(props?.BetPlaceData?.team1 ? [{ runner_name: props.BetPlaceData.team1, selection_id: "team1", exposure: 0 }] : []),
              ...(props?.BetPlaceData?.team2 ? [{ runner_name: props.BetPlaceData.team2, selection_id: "team2", exposure: 0 }] : []),
              ...(props?.BetPlaceData?.runner_name && !props?.BetPlaceData?.team1 && !props?.BetPlaceData?.team2
                ? [{ runner_name: props.BetPlaceData.runner_name, selection_id: props?.BetPlaceData?.selection_id, exposure: 0 }]
                : []),
            ];

          return runners.map((runner) => {
            let exposure = runner.exposure;
            const odds = parseFloat(props?.BetPlaceData?.price);
            const stake = parseFloat(props?.StakeValue) || 0;
            if (props?.StakeValue && props?.BetPlaceData?.price) {
              if (runner.selection_id === props?.BetPlaceData?.selection_id) {
                if (props?.type === "back") {
                  exposure = ((odds - 1) * stake);
                } else {
                  exposure = ((odds - 1) * stake * -1);
                }
              } else {
                if (props?.type === "back") {
                  exposure = -stake;
                } else {
                  exposure = stake;
                }
              }
            }
            return (
              <div key={runner.runner_name} className="flex items-center justify-between gap-2">
                <span className="text-[#000] text-sm font-bold">
                  {runner.runner_name}
                </span>
                <span
                  className={
                    exposure > 0
                      ? 'text-green-700 text-sm font-bold'
                      : exposure < 0
                        ? 'text-red-600 text-sm font-bold'
                        : 'text-gray-700 text-sm font-bold'
                  }
                >
                  <span
                    style={{
                      marginLeft: 8,
                      color: exposure < 0
                        ? "#ff0000"
                        : exposure > 0
                          ? "#228b22"
                          : "#000000", // black for zero
                      fontWeight: "bold",
                      fontSize: "0.9em"
                    }}
                  >
                    {typeof exposure === 'number' ? exposure.toFixed(2) : '0.00'}
                  </span>
                </span>
              </div>
            );
          });
        })()}
      </div>
      {/* ===== EXISTING CONTENT ENDS HERE ===== */}


      {/* ===== NEW OVERLAY CODE STARTS HERE ===== */}
      {props?.placing && (
        <div className="placing-overlay">
          <div className="overlay-content flex gap-8">
            <p className="overlay-text">
              Placing Bet... Please Wait
            </p>
            <span className="loader"></span>
          </div>
        </div>
      )}
      {/* ===== NEW OVERLAY CODE ENDS HERE ===== */}
    </div>
  );
};

export default PlaceBet;